import { Category, PayloadCategory } from '@/types/category'
import { api } from '@/utils/api'
import { apiCategory } from '@/utils/api/url'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { QUERY_KEY_CATEGORY } from './useGetCategories'
import { useTranslation } from 'react-i18next'

const messageKey = 'add-category'
export const useAddCategory = () => {
  const { t } = useTranslation('catalog')
  const queryClient = useQueryClient()
  const { message } = App.useApp()
  const category = useMutation({
    mutationFn: ({
      branch,
      payload,
    }: {
      branch: string
      payload: PayloadCategory
    }) =>
      api
        .post(createRouteForAPI(apiCategory, { branch }), payload)
        .then(({ data }) => data as Category),
    onMutate: () => {
      message.loading({
        key: messageKey,
        content: t('catalog.category.adding'),
      })
    },
    onSuccess: (_, payload) => {
      message.success({
        key: messageKey,
        content: t('catalog.category.added'),
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_CATEGORY, payload.branch],
      })
    },
    onError: () => {
      message.destroy(messageKey)
    },
  })

  return category
}
